import React from "react";
import styles from "./ProgramStickyForm.module.css";
import Image from "next/image";
import CustomiseCta from "../CustomiseCta/CustomiseCta";

interface ProgramStickyFormProps {
  handleBroutcherButtonClick: (broutcherLink?: string) => void;
  handleEnrollButtonVidio: (videoLink: string) => void;
  popUpData?: any;

  data?: {
    video_preview_link?: {
      link?: {
        url?: string;
      };
      image?: {
        url?: any;
        alternativeText?: any;
      };
    };
    list_items?: {
      title: string;
      description: string;
    }[];
    brochure_pdf_link?: {
      url: any;
    };
    request_call_cta?: any;
  };
}

const ProgramStickyForm: React.FC<ProgramStickyFormProps> = ({
  data,
  handleBroutcherButtonClick,
  handleEnrollButtonVidio,
  popUpData,
}) => {
  return (
    <div className={styles.formContainer}>
      <div className={styles.thumbnail}>
        <Image
          src={data?.video_preview_link?.image?.url}
          alt={
            data?.video_preview_link?.image?.alternativeText ||
            "Thumbnail Image"
          }
          title={
            data?.video_preview_link?.image?.alternativeText ||
            "Thumbnail Image"
          }
          className={styles.image}
          width={248}
          height={180}
        />
        {data?.video_preview_link?.link?.url && (
          <div
            onClick={() =>
              handleEnrollButtonVidio(data?.video_preview_link?.link?.url || "")
            }
          >
            <Image
              src="/assets/play-icon.svg"
              className={styles.playIcon}
              width={44}
              height={44}
              alt={"play-icon"}
              title={"play-icon"}
            />
          </div>
        )}
      </div>
      <div className={styles.content}>
        {data?.list_items?.map((item, index) => (
          <div key={index} className={styles.detailItem}>
            <span>{item?.title}: </span>
            <strong>{item?.description}</strong>
          </div>
        ))}
      </div>
      <div className={styles.requestButton}>
        <CustomiseCta
          ctaData={data?.request_call_cta}
          btnLabelDesktop="Enrol Now"
          preEnrollmentEnable
          imageIconRight="/assets/Group-icon.svg"
          mixpanelEvent="enrol_now_clicked"
          popupData={popUpData}
        />
      </div>

      <p className={styles.textAdress}>
        Contact the Regenesys Admissions Department at <b>+27 (11) 669 5000 </b>
        for more details regarding the programme
        <br />
        <span>(or)</span>
      </p>
      <button
        className={styles.downloadButton}
        onClick={() => {
          handleBroutcherButtonClick("Download Brochure");
        }}
      >
        {/* <LuDownload /> */}
        <Image
          src="/assets/Download.svg"
          alt="download_icon"
          title="download_icon"
          width={16}
          height={16}
        />
        Download Brochure
      </button>
    </div>
  );
};

export default ProgramStickyForm;
